export const publishersConstants = {
  SET_PUBLISHERS: 'SET_PUBLISHERS',
  SELECT_PUBLISHERS: 'SELECT_PUBLISHERS',
};
